import axios from '@/http/index';

const base = '';
// (4.1)获得全部订单列表
export const getAllOrderListPage = (params) => axios.get(`${base}/erp/customerOrder/getAllOrderListPage`, params).then((res) => res.data);
// (6.6)获得全部订单列表
export const getAllOrderListPageBean = (params) => axios.post(`${base}/erp/customerOrder/getAllOrderListPageBean`, params).then((res) => res.data);
// 服务开单记录列表
export const getFwkd = (params) => axios.get(`${base}/erp/statistics/toProductSaleList`, params).then((res) => res.data);
// 快捷收银记录列表
export const getQuickCashList = (params) => axios.post(`${base}/erp/statistics/getQuickCashList`, params).then((res) => res.data);
// 查询会员套餐订单记录
export const selectVipCardOrderList = (params) => axios.get(`${base}/erp/lookVipCard/selectVipCardOrderList`, params).then((res) => res.data);
// 赠送记录列表
export const getZs = (params) => axios.get(`${base}/erp/statistics/toServiceFee`, params).then((res) => res.data);
// 套餐购买记录列表
export const getTcgm = (params) => axios.get(`${base}/erp/package/getPackageList`, params).then((res) => res.data);
// 查看订单详情
export const getOrderDetails = (params) => axios.get(`${base}/erp/customerOrder/getOrderDetails`, params).then((res) => res.data);
// 获取首页未完成订单列表
export const getIndexOrderList = (params) => axios.get(`${base}/erp/home/getCustomerOrderList`, params).then((res) => res.data);
// 获得员工当前值班状态信息
export const getVacationListByStatus = (param) => axios.get(`${base}/erp/vacation/getVacationListByStatus`, param).then((res) => res.data);
// (4.1订单详情)获得服务开单订单详情
export const getOrderDetail4AllDto = (param) => axios.get(`${base}/erp/customerOrder/getOrderDetail4AllDto`, param).then((res) => res.data);
// (4.1)获得订单列表数量
export const getAllOrderCount = (param) => axios.get(`${base}/erp/customerOrder/getAllOrderCount`, param).then((res) => res.data);
// (6.6)获得订单列表数量
export const getAllOrderCountBean = (param) => axios.post(`${base}/erp/customerOrder/getAllOrderCountBean`, param).then((res) => res.data);

// 4.4.0待确认状态  确认和拒绝事件  确认是1或取消是0
export const getSureOrFalse = (param) => axios.get(`${base}/busmanage/booksOrder/getSureOrFalse`, param).then((res) => res.data);
// 取消预约
export const getBookFailures = (param) => axios.get(`${base}/erp/bookOrder/bookFailures`, param).then((res) => res.data);

// 5.10订单点击退房
export const getCheckOutOrder = (param) => axios.get(`${base}/room/checkOutOrder`, param).then((res) => res.data);

// (6.6)获取房间列表
export const getSearchRoomList = (param) => axios.get(`${base}/erp/customerOrder/getSearchRoomList`, param).then((res) => res.data);

// (6.9)查询订单导出列表设置功能
export const getOrderEntryListByMainId = (param) => axios.get(`${base}/erp/customerOrder/getOrderEntryListByMainId`, param).then((res) => res.data);

// (6.9)保存或更新列表设置功能
export const saveOrUpdateEntry = (param) => axios.post(`${base}/erp/customerOrder/saveOrUpdateEntry`, param).then((res) => res.data);

// 重置默认列表设置功能
export const updateDefaultEntry = (param) => axios.get(`${base}/erp/customerOrder/updateDefaultEntry`, param).then((res) => res.data);
